export default __webpack_public_path__ + "static/media/logo.39ff8038.svg";